
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      shoppingTitle: "",
      shoppingTitleKey: ""
    };
  },
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    configType: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.baseInfo?.detailVOS.forEach(infoItem => {
      if (infoItem.fieldCode == "SHOW_NAME") {
        this.shoppingTitle = infoItem.fieldContent;
        this.shoppingTitleKey = infoItem.fieldName;
      }
    });
    if (this.shoppingTitle == "") {
      this.baseInfo?.detailVOS.forEach(infoItem => {
        if (infoItem.fieldName == "商品名称") {
          this.shoppingTitle = infoItem.fieldContent;
          this.shoppingTitleKey = infoItem.fieldName;
        }
      });
    }
  }
});
